import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

// Returnerar en "grupp-nyckel" för rutter där vi inte vill scrolla upp
// vid byte mellan undersidor (t.ex. /filmer ↔ /filmer/kommuner).
const getScrollGroup = (pathname: string): string | null => {
  const match = pathname.match(/^\/(sv|en)\/filmer(\/|$)/);
  if (match) return `${match[1]}/filmer`;
  return null;
};

const ScrollToTop = () => {
  const { pathname } = useLocation();
  const prevGroupRef = useRef<string | null>(getScrollGroup(pathname));

  useEffect(() => {
    const currentGroup = getScrollGroup(pathname);
    const prevGroup = prevGroupRef.current;
    prevGroupRef.current = currentGroup;

    // Hoppa över scroll om vi navigerar inom samma grupp (t.ex. filmer-filter)
    if (currentGroup && currentGroup === prevGroup) return;

    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTop;
